import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import Colortheme from './Theme/Colortheme';
import Game from './Components/Game';
import Startpage from './Components/Startpage';
import TutorialCarousel from './Components/TutorialCarousel';
import Logo from './Components/Logo';
import SharePage from './Components/SharePage';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.style = {
            startpageHeader: {
                minHeight: '100vh',
                backgroundColor: Colortheme.backgroundColor,
                overflow: 'hidden'
            },
        };
    }

    render() {
        return (
            <Router>
                <div style={this.style.startpageHeader} align='center'>
                    <Logo />

                    <Switch>
                        <Route path='/lobby/:lobbyCode' render={(props) => {
                            if (!props.location.state) {
                                return <Redirect to={{
                                    pathname: '/home',
                                    state: { lobbyCode: decodeURIComponent(props.match.params.lobbyCode) }
                                }} />
                            }
                            return <Game {...props} />
                        }} />
                        <Route exact path='/tutorial' component={TutorialCarousel} />
                        <Route exact path='/home' component={Startpage} />
                        <Route path='/share/:imageId' render={(props) => {
                            return <SharePage {...props} />
                        }} />
                        <Route path='/'>
                            <Redirect to='/home' />
                        </Route>
                    </Switch>
                </div>
            </Router>);
    }
}

export default App;
